<template>
  <div>
    <b-modal
      @ok="createUser"
      @cancel="hideModal"
      no-close-on-backdrop
      ref="ModalUnitAndBatch"
      size="md"
      :title="product.name"
      centered
      hide-footer
      header-class="bt-modal-header"
      body-class="bt-modal-body"
    >
      <!-------------------- Modal Header -------------------->
      <template #modal-header="{ close }">
        <div>
          <div class="bt-modal-title">{{ modalTitle }}</div>
          <div class="current-price-container">
            <b-form-checkbox
              size="lg"
              @input="updateMinPrice"
              v-model="minPriceVisible"
            >
            </b-form-checkbox>
            <p>Set Current Price</p>
          </div>
        </div>
        <b-button size="sm" variant="outline-danger" @click="close()">
          Close
        </b-button>
      </template>

      <!-------------------- Modal Body -------------------->

      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-row>
      <b-row
        v-if="product.units.length == 0 && !loading"
        class="pl-3 pr-3 text-center"
      >
        <b-col>
          <b-alert show variant="warning">No stock available </b-alert>
        </b-col>
      </b-row>
      <b-row v-if="product.units.length != 0 && !loading">
        <!-- <b-col cols="6" class="text-center ">
          <h4 class="font-poppins">Units</h4>

          <div v-for="(unit, unitIndex) in product.units" :key="unitIndex">
            <div @click="selectUnit(unit)" :class="[
              unit.id == selectedUnit.id ? 'unit m-1 selected' : 'unit m-1',
              unit.is_purchasing_unit == true ? 'purchasingUnit m-1' : '',
            ]">
              {{ unit.name }}
            </div>
          </div>
        </b-col> -->
        <b-col cols="12" class="text-center">
          <b-row v-if="isStockAvailable(selectedUnit.batches)">
            <b-col cols="4" class="pt-1"> </b-col>
          </b-row>
          <div
            v-for="(batch, batchIndex) in selectedUnit.batches"
            :key="batchIndex"
          >
            <b-row v-if="batch.available_stock > 0">
              <b-col cols="12">
                <div>
                  <div
                    @click="batch.isBargained ? '' : selectBatch(batch)"
                    :class="
                      batch.id == selectedBatch.id
                        ? 'batch_container m-1 selected_batch'
                        : 'batch_container m-1'
                    "
                  >
                    <b-row
                      @click.stop="batch.isBargained ? '' : selectBatch(batch)"
                    >
                      <b-col class="text-left">
                        <div class="batch_name mb-1">
                          Batch {{ batch.batch }}
                        </div>

                        <div
                          class="batch_amount"
                          v-if="
                            minPriceVisible || product.minCurrentMoneyVisible
                          "
                        >
                          {{
                            minPriceVisible
                              ? selectedUnit.min_price
                              : batch.selling_price
                          }}/=
                        </div>
                        <div class="batch_amount" v-else>
                          <!-- {{ product.min_price}} /= -->

                          {{ batch.selling_price }}/=
                        </div>
                      </b-col>
                      <b-col>
                        <div class="font-poppins stock-icon m-auto">
                          <i
                            class="fa fa-cart-arrow-down"
                            aria-hidden="true"
                          ></i>
                          {{ batch.available_stock }}
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { ProductModel } from "@/models/ProductModel";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import axios from "@/plugins/axios";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { mapState, mapGetters } from "vuex";
import { BIconCreditCard2Back } from "bootstrap-vue";

export default {
  name: "PickProductUnitandBatch",
  methods: {
    formatter(amount) {
      return value > amount ? amount : value;
    },
    isStockAvailable(data) {
      if (data) {
        const result = data.filter((item) => item.available_stock > 0);
        return result.length != 0;
      }
    },
    calculatePercentage(item, index) {
      // if (parseInt(item.bargained_amount) > parseInt(item.selling_price)) {
      //   item.bargained_amount = item.selling_price;
      //   return;
      // }
      // if (parseInt(item.bargained_amount) < 0) {
      //   item.bargained_amount = 0;
      //   return;
      // }
      if (this.minPriceVisible) {
        this.result = (item.bargained_amount / this.product.min_price) * 100;
      } else {
        this.result = (item.bargained_amount / item.selling_price) * 100;
      }
      if (this.result % 1 == 0) {
        item.bargained_percentage = this.result;
        if (this.$refs.bargainedPercentage.length > 0) {
          this.$refs.bargainedPercentage.forEach((item) => {
            item.value = this.result;
          });
        } else {
          this.$refs.bargainedPercentage.value = this.result;
        }
        // this.selectedUnit.batches[index].bargained_percentage = result;
      } else {
        item.bargained_percentage = this.result.toFixed(2);
        if (this.$refs.bargainedPercentage.length > 0) {
          this.$refs.bargainedPercentage.forEach((item) => {
            item.value = this.result;
          });
        } else {
          this.$refs.bargainedPercentage.value = this.result;
        }
        // this.selectedUnit.batches[index].bargained_percentage = result.toFixed(
        //   2
        // );
      }
    },
    calculateAmount(item) {
      // if (parseInt(item.bargained_percentage) > parseInt(100)) {
      //   item.bargained_percentage = 100;

      //   if (this.$refs.bargainedPercentage.length > 0) {
      //     this.$refs.bargainedPercentage.forEach((items) => {
      //       items.value = 100;
      //     });
      //   } else {
      //     this.$refs.bargainedPercentage.value = 100;
      //   }
      //   return;
      // }
      // if (parseFloat(item.bargained_percentage) < 0) {
      //   item.bargained_percentage = 0;
      //   return;
      // }

      if (this.minPriceVisible) {
        var amount = (item.bargained_percentage * this.product.min_price) / 100;
      } else {
        var amount = (item.bargained_percentage * item.selling_price) / 100;
      }
      item.bargained_amount = amount;
      if (this.$refs.bargainedAmount.length > 0) {
        this.$refs.bargainedAmount.forEach((items) => {
          items.value = amount;
        });
      } else {
        this.$refs.bargainedAmount.value = amount;
      }
    },
    // AddBargainAmount(value, batchIndex) {
    // this.$store.commit("bill/ADD_BARGAIN_AMOUNT", {
    //   value,
    //   batchIndex,
    //   batchIndex: this.selectedbatchIndex,
    // });
    //   this.selectedBatch[batchIndex].bargained_amount = value;
    // },
    focusAmountTextBox(value, batch) {
      // batch.bargained_percentage = 0;
      // batch.bargained_amount = 0;
      if (value) {
        this.$refs.bargainedAmount[0].focus();
      }
    },
    initiate() {
      this.fetchCount = 0;
      this.product = Object.assign({}, ProductModel);
      this.selectedUnit = {};
      this.selectedBatch = {};
      this.selectedBatchIndex = {};
      this.errorSellingAmountExceed = null;
    },
    selectUnit(unit) {
      this.selectedUnit = unit;
      // this.selectedUnit.batches.map((item) => {
      //   if (!item.isBargained) {
      //     item.isBargained = null;
      //     item.bargained_percentage = null;
      //     item.bargained_amount = null;
      //   }
      //   return item;\
      // });
    },
    selectBatch(batch, index) {
      if (
        parseFloat(batch.bargained_amount) >
          parseFloat(
            this.minPriceVisible == true
              ? this.product.min_price
              : batch.selling_price
          ) ||
        parseInt(batch.bargained_percentage) > 100 ||
        parseFloat(batch.bargained_amount) < 0
      ) {
        this.errorSellingAmountExceed = true;
        return;
      }
      this.errorSellingAmountExceed = false;

      this.selectedBatch = batch;
      if (
        batch.bargained_amount == undefined &&
        batch.bargained_percentage == undefined
      ) {
        batch.bargained_amount = 0;
        batch.bargained_percentage = 0;
      }
      this.selectedBatchIndex = index;
      // Available Stock
      axios
        .post(
          "pos/shops/" +
            this.shop_info.id +
            "/product/" +
            this.data.id +
            "/batch/" +
            this.selectedBatch.id +
            "/unit/" +
            this.selectedUnit.id,
          this.GetSelectedProductUnitsAndQuantity(this.data.id, 0)
        )
        .then((res) => {
          if (res.data?.data?.available_stock > 0) {
            this.$emit("addProduct", {
              batch: batch,
              unit: this.selectedUnit,
              available_stock: res.data.data.available_stock,
              setCurrentMoney: this.product.min_price,
              setCurrentMoneyVisible: this.minPriceVisible,
              batches: this.product.units,
              productInformation: this.productInformation,
            });

            // if (!this.isShowModal) {
            // this.hideModal();
            // }
          } else {
            this.showToast("No Available Stock", "danger");
          }
        })
        .catch((err) => {});
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: `Message`,
        variant: variant,
        solid: true,
      });
    },
    fetchProduct() {
      this.loading = true;
      var productId = this.data.id;
      this.$store
        .dispatch("product/fetchUnitAndBatchWhenUpdateProduct", {
          productId: this.data.id,
          selectedUnits: this.GetSelectedProductUnitsAndQuantity(this.data.id),
        })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            /* ----- Set the bargained_amount & bargained_percentage -----*/
            var productData = res.data.data;
            productData.units.map((item) => {
              item.batches.map((batchItem) => {
                batchItem.bargained_amount = 0;
                batchItem.bargained_percentage = 0;
              });
            });
            /* -------------------------------------------------------------*/

            this.product = productData;
            this.productInformation = productData;

            if (productData.units.length >= 1 && this.autoSelectUnitAndBatch) {
              var selectedUnit = this.product.units.find(
                (u) => u.id == productData.units[0].id
              );
              this.selectUnit(selectedUnit);
              for (let i = 0; i < selectedUnit.batches.length; i++) {
                if (i == selectedUnit.batches.length - 1) {
                  this.selectBatch(selectedUnit.batches[i], i);
                } else if (selectedUnit.batches[i].available_stock > 0) {
                  this.selectBatch(selectedUnit.batches[i], i);
                  break;
                }
              }

              return;
            }
            this.selectUnit(
              this.product.units.find((u) => u.id == this.data.unit.id)
            );
          } else if (res.status == 204) {
            this.product = Object.assign({}, ProductModel);
            this.product.name = this.data.name;
            this.reloadContent();
          }
          this.product.unit = {
            id: this.data.unit.id,
            name: this.data.unit.name,
          };
        })
        .catch((err) => {
          this.loading = false;
          this.suspend_lists = [];
        });
    },
    reloadContent() {
      if (this.fetchCount < 2) {
        this.fetchProduct();
        this.fetchCount++;
      }
    },
    disableAutoSelect() {
      this.autoSelectUnitAndBatch = false;
    },
    showModal(isShowModal, minPriceVisible) {
      this.isShowModal = isShowModal;
      this.loading = true;
      this.initiate();
      this.minPriceVisible = false;
      setTimeout(() => {
        this.fetchProduct();
      }, 200);

      if (!this.autoSelectUnitAndBatch || this.isShowModal) {
        this.$refs["ModalUnitAndBatch"].show();
        this.minPriceVisible = minPriceVisible;
      }
    },
    hideModal() {
      this.$refs["ModalUnitAndBatch"].hide();
    },
    createUser() {},
    updateMinPrice(value) {
      this.$emit("setCurrentAmount", {
        value,
        data: this.selectedUnit,
      });
    },
  },

  props: {
    data: {
      type: [String, Object],
      default: {},
    },
    selectedUnit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    selectedBatch: {
      type: Object,
      default: function () {
        return {};
      },
    },
    // product:[],
  },
  data: () => ({
    autoSelectUnitAndBatch: true,
    isShowModal: false,
    // dialog: false
    // tab: 0,
    loading: null,
    product: Object.assign({}, ProductModel),
    // selectedUnit: [],
    //selectedUnit:this.selectedUnit,
    // selectedBatch: [],
    selectedBatchIndex: {},
    result: null,
    minPriceVisible: false,
    fetchCount: 0,
    mockSwipeList: [
      {
        id: 0,
        title: "Some title",
        description: "some description",
      },
      {
        id: 1,
        title: "Some title",
        description: "some description",
      },
      {
        id: 2,
        title: "Some title",
        description: "some description",
      },
    ],
    errorSellingAmountExceed: false,
    productInformation: {},
  }),
  components: {
    SwipeOut,
    SwipeList,
  },
  computed: {
    ...mapState("shops", ["shop_info"]),
    ...mapGetters("bill", ["GetSelectedProductUnitsAndQuantity"]),
    productName: function () {
      return this.product ? this.product.name : "";
    },
    productUnit: function () {
      if (this.product?.unit) {
        return " ( " + this.product.unit.name + ")";
      }
      return "";
    },
    modalTitle: function () {
      if (this.productName && this.productUnit) {
        return this.productName + this.productUnit;
      }
      return "";
    },
  },
  mounted: function () {
    // this.initialize();
  },
};
</script>

<style>
.unit,
.batch_container {
  /* font-family: "Poppins";
  font-weight: 600;
  border: 1px solid #634a00;
  border-radius: 11px;
  text-align: center;
  box-shadow: 1px 1px 0px 0px black; */
  padding: 20px 11px;
  border-bottom: 1px dashed #d86a42;
}

.selected_batch {
  /* background-color: #ffc107;
  color: #162947;
  box-shadow: unset;
  border: 1px solid white; */
}

.batch_name {
  font-size: 16px;
  font-weight: 800;
  font-familt: "Times New Romans";
}

.batch_amount {
  font-size: 14px;
  font-weight: 600;
}

.stock-icon {
  background-color: #ffb800;
  width: 74px;
  padding: 4px;
  border-radius: 15px;
}

.unit:hover,
.unit:active,
.batch_container:hover {
  /* background-color: #ffd557;
  border: 1px solid #ffd557;
  color: #162947; */
}

.purchasingUnit {
  background-color: #27362c2e;
  color: #162947;
  box-shadow: unset;
  border: 1px solid white;
}

.bt-modal-title {
  color: #087592;
  font-size: 16px;
  margin-bottom: 15px;
}

.bt-modal-header {
  padding-bottom: 0px !important;
  border-bottom: 0.5px solid #d86a42;
}

.bt-modal-body {
  padding-top: 0px !important;
}

.current-price-container {
  display: flex;
}
</style>
